// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import fastClick from 'fastclick'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'babel-polyfill'
import store from './store/index.js'
import 'styles/reset.css'
import 'styles/border.css'
import 'styles/iconfont.css'
import 'swiper/dist/css/swiper.css'
import "styles/common.css"
import Vant from 'vant'
import 'vant/lib/index.css'
import i18n from "./i18n"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI,{ locale });
// import 'amfe-flexible'

Vue.config.productionTip = false;   //阻止启动生产消息
fastClick.attach(document.body);
Vue.use(VueAwesomeSwiper);
Vue.use(Vant);

router.beforeEach((to,from,next)=>{
  if(to.meta.requireAuth){
    if(localStorage.getItem("LOGIN_INFO")){
      next()
    }else{
      next({
        path:"/",
      })
    }
  }else{
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n, //!!!国际化
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js